<template>
  <v-row>
    <v-col cols="10">
      <v-row>
        <v-col cols="12" sm="4">
          <gg-select
            outlined
            :items="select.part"
            item-text="title"
            item-value="value"
            v-model="model.part"
            @change="changed"
          ></gg-select>
        </v-col>
        <v-col cols="12" sm="4">
          <gg-select
            outlined
            :items="select.match"
            item-text="title"
            item-value="value"
            v-model="model.match"
            @change="changed"
          ></gg-select>
        </v-col>
        <v-col cols="12" sm="4">
          <gg-select
            outlined
            :items="select.opt"
            item-text="title"
            item-value="value"
            v-model="model.opt"
            @change="changed"
          ></gg-select>
        </v-col>
        <v-col cols="12">
          <gg-text-field
            label="Enter a filter rule"
            outlined
            v-model="model.val"
            v-validate="rules.filter_rule"
            data-vv-name="filter_rule"
            data-vv-as="Filter rule"
            :error-messages="errors.collect('filter_rule')"
            @change="changed"
          >
          </gg-text-field>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="2">
      <v-row>
        <v-col cols="6">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <gg-btn v-on="on" elevation="0" text @click="sort('up')">
                ▲
              </gg-btn>
            </template>
            <span>Move filter up</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <gg-btn v-on="on" elevation="0" text @click="sort('down')">
                ▼
              </gg-btn>
            </template>
            <span>Move filter down</span>
          </v-tooltip>
        </v-col>
        <v-col cols="6">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <gg-btn v-on="on" elevation="0" text @click="addRuleItem">
                <v-icon>mdi-plus</v-icon>
              </gg-btn>
            </template>
            <span>Add new filter</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <gg-btn v-on="on" elevation="0" text @click="removeRuleItem">
                <v-icon>mdi-minus</v-icon>
              </gg-btn>
            </template>
            <span>Delete filter</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'Rules',
  data: () => ({
    select: {
      part: [
        {
          value: '$header_from:',
          title: 'From',
          disabled: false
        },
        {
          value: '$header_subject:',
          title: 'Subject',
          disabled: false
        },
        {
          value: '$header_to:',
          title: 'To',
          disabled: false
        },
        {
          value: '$reply_address:',
          title: 'Reply',
          disabled: false
        },
        {
          value: '$message_body',
          title: 'Body',
          disabled: false
        },
        {
          value: '$message_headers',
          title: 'Any Header',
          disabled: false
        },
        {
          value: 'foranyaddress $h_to:,$h_cc:',
          title: 'Any Recipient',
          disabled: false
        },
        {
          value: 'not delivered',
          title: 'Has Not Been Previously Delivered',
          disabled: false
        },
        {
          value: 'error_message',
          title: 'Is an Error Message',
          disabled: false
        },
        {
          value: '$h_List-Id:',
          title: 'List ID',
          disabled: true
        },
        {
          value: '$h_X-Spam-Status:',
          title: 'Spam Status',
          disabled: true
        },
        {
          value: '$h_X-Spam-Bar',
          title: 'Spam Bar',
          disabled: true
        },
        {
          value: '$h_X-Spam-Score',
          title: 'Spam Score',
          disabled: true
        }
      ],
      match: [
        {
          value: 'contains',
          title: 'contains',
          disabled: false
        },
        {
          value: 'matches',
          title: 'matches regex',
          disabled: false
        },
        {
          value: 'does not contain',
          title: 'does not contain',
          disabled: false
        },
        {
          value: 'is',
          title: 'equals',
          disabled: false
        },
        {
          value: 'begins',
          title: 'begins with',
          disabled: false
        },
        {
          value: 'ends',
          title: 'ends with',
          disabled: false
        },
        {
          value: 'does not begin',
          title: 'does not begin',
          disabled: false
        },
        {
          value: 'does not end with',
          title: 'does not end with',
          disabled: false
        },
        {
          value: 'does not match',
          title: 'does not match',
          disabled: false
        },
        {
          value: 'is above',
          title: 'is above (numbers only)',
          disabled: true
        },
        {
          value: 'is not above',
          title: 'is not above (numbers only)',
          disabled: true
        },
        {
          value: 'is below',
          title: 'is below (numbers only)',
          disabled: true
        },
        {
          value: 'is not below',
          title: 'is not below (numbers only)',
          disabled: true
        }
      ],
      opt: [
        {
          value: 'or',
          title: 'or',
          disabled: false
        },
        {
          value: 'and',
          title: 'and',
          disabled: false
        },
      ]
    },
    model: {
      part: '$header_from:',
      match: 'contains',
      opt: 'and',
      val: ''
    },
    rules: {
      filter_rule: {
        required: true
      }
    }
  }),
  props: {
    index: {
      type: Object
    },
    index_in_array: {
      type: Number
    },
    array_length: {
      type: Number
    },
    rule: {
      type: Object
    }
  },
  methods: {
    changed () {
      this.$nextTick(() => {
        let rules = {}
        for (let prop in this.model) {
          rules['index'] = this.index.id
          rules[prop] = {
            value: this.model[prop],
            rule_name: `${prop}${this.index.id}`
          }
        }
        this.$emit('changed', rules)
      })
    },
    addRuleItem () {
      this.$emit('add')
    },
    removeRuleItem () {
      this.$emit('remove', this.index)
    },
    sort (type) {
      let sortUp = {
        new_index: this.index_in_array - 1,
        old_index: this.index_in_array
      }
      let sortDown = {
        new_index: this.index_in_array + 1,
        old_index: this.index_in_array
      }

      if (type === 'up') {
        this.$emit('sort_up', sortUp)
      } else {
        this.$emit('sort_down', sortDown)
      }
    }
  },
  inject: ['parentValidator'],
  created () {
    this.$validator = this.parentValidator

    this.$nextTick(() => {
      if (this.rule !== undefined) {
        this.model.part = this.rule.part
        this.model.match = this.rule.match
        this.model.opt = this.rule.opt
        this.model.val = this.rule.val
      }
    })
  },
  mounted () {
    this.changed()
  }
}
</script>

<style scoped lang="scss">
  .filter-container {
    display: flex;
    flex-basis: 100%;
    justify-content: space-between;
  }

  .filter-form {
    display: flex;
    flex-direction: column;
    flex-basis: 90%;
  }

  .filter-controls {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    > div {
      display: flex;
      flex-direction: column;
    }
  }

  .filter-select {
    display: flex;
    flex-basis: 100%;
    .part, .match, .opt {
      flex-basis: 100%;
    }
    .part {
      padding-right: 15px
    }
    .opt {
      padding-left: 15px
    }
  }

  .filter-input {
    padding-top: 15px;
  }
</style>
